import { defineStore } from 'pinia'
import { getPosts } from '../services/posts'
import { sanitizeText, linksToHtml } from '../helpers'
import { deletePost } from '../api/posts'
import { notifyError } from '../services/logger'

export const usePostsStore = defineStore('posts', {
  state: () => ({
    delpastor: [],
    most_commented: [],
    starred: [],
    posts: [],
    newPostFiles: [],
  }),
  actions: {
    loadCategoryPosts(categories) {
      categories.forEach(async category => {
        try {
          const { posts } = await getPosts({ category, summarized: true })
          this[category] = posts
        } catch (err) {
          notifyError(err)
          throw new Error(err)
        }
      })
    },
    setPosts(posts) {
      this.posts = posts
    },
    updateLocalPost(id, props) {
      const postIndex = this.posts.findIndex(post => post.id === id)
      this.posts[postIndex] = { ...this.posts[postIndex], ...props }
    },
    async deletePost(id) {
      const postIndex = this.posts.findIndex(post => post.id === id)
      this.posts.splice(postIndex, 1)
      deletePost(id)
    },
    addPostToHome(post) {
      const sanitizedPost = sanitizeText(post.content)
      post = { ...post, content: linksToHtml(sanitizedPost) }
      this.posts = [post, ...this.posts]
    },
    clearFiles() {
      this.newPostFiles = []
    },
    addFile(file) {
      this.newPostFiles.push(file)
    },
    removeFile(file) {
      const index = this.newPostFiles.indexOf(file)
      this.newPostFiles.splice(index, 1)
    },
  },
  getters: {
    getSummarizedPosts: state => category => {
      return state[category]
    },
    fileListHasVideo: state => {
      return state.newPostFiles.some(file => file.type === 'video')
    },
    totalFilesSize: state => {
      return state.newPostFiles.reduce((acc, file) => acc + file.size, 0)
    },
  },
})
